import { Input } from "antd"
import { t } from "i18next"
import React from "react"
import { InputSearchProps } from "../../../../lib/config/types"

const SearchInput: React.FC<InputSearchProps> = ({ handleSearchChange }) => {
  return (
    <div className="h-full flex flex-row gap-4">
      <Input type="search" className="custom-input" onChange={handleSearchChange} placeholder={t("Search Media")} />
    </div>
  )
}

export default SearchInput
